import csvToJson from '../csvToJson'


function readTUConfiguration(tuConfiguration) {
    // Read this again every time so you get a deep copy when you request it
    console.log({
        "msg": "readTUConfiguration",
        "component": "technischeUntersuchungen"
    })
    return csvToJson(tuConfiguration).filter(line => line.ID !== '')
}

export default {readTUConfiguration: readTUConfiguration}